"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _ui = require("../ui");
var _excluded = ["onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SelectInput = function SelectInput(_ref) {
  var inputProps = _ref.inputProps,
    control = _ref.control,
    className = _ref.className;
  var _useController = (0, _reactHookForm.useController)({
      name: inputProps.name,
      control: control,
      defaultValue: inputProps.defaultValue
    }),
    _useController$field = _useController.field,
    _onChange = _useController$field.onChange,
    onBlur = _useController$field.onBlur,
    value = _useController$field.value,
    _useController$fieldS = _useController.fieldState,
    invalid = _useController$fieldS.invalid,
    error = _useController$fieldS.error;
  var onSelectInputChange = inputProps.onChange,
    props = _objectWithoutProperties(inputProps, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.SelectInput, _extends({
    className: className,
    value: value,
    onBlur: onBlur,
    invalid: invalid
  }, props, {
    onChange: function onChange(value) {
      _onChange(value);
      onSelectInputChange === null || onSelectInputChange === void 0 ? void 0 : onSelectInputChange(value);
    }
  })), error && /*#__PURE__*/_react.default.createElement(_ui.FormFeedback, {
    valid: false
  }, error === null || error === void 0 ? void 0 : error.message));
};
exports.SelectInput = SelectInput;